import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { CALENDAR_CELLS_GAP } from '@/components/_common/Table/Calendar/constants';

type ColumnHeaderProps = {
  label: string;
};

const ColumnHeader = ({ label }: ColumnHeaderProps) => {
  return <ColHeader>{label}</ColHeader>;
};

export default ColumnHeader;

const ColHeader = styled(Box)`
  margin-bottom: -${CALENDAR_CELLS_GAP}px;
  padding: ${({ theme }) => theme.spacing(1.25)};
  background: ${({ theme }) => theme.palette.background.paper};
  text-align: center;
  font-size: 1.143rem;
  color: ${({ theme }) => theme.palette.common.white};
`;
